module.exports = __webpack_public_path__ + "static/media/plus.3dfb1b63.svg";